import { baseUrl } from '../config/clientsConfig'
import axios from "axios";

const userServices = {
    validateEmailId: (emailId) =>
        axios.post(`${baseUrl}/userValidateEmailId`, { emailId }),
    validatePhoneNumber: (phoneNumber) =>
        axios.post(`${baseUrl}/userValidatePhoneNumber`, { phoneNumber }),
    createUser: (userData) => axios.post(`${baseUrl}/user`, userData),
    fetchUsers: async (category) => {
        let url;
        if (category === "All Users") {
            url = `${baseUrl}/users`;
        } else {
            url = `${baseUrl}/user/getusers/byrole?role=${category.toUpperCase()}`;
        }
        return axios.get(url);
    },
    fetchLeadGivenByUsers: async ()=>{
return axios.get(`${baseUrl}/users`)
    },
    updateUser: (userId, updatedUserData) =>
        axios.put(`${baseUrl}/user/${userId}`, updatedUserData),
    checkUserDeactivation : (body) =>
        axios.post(`${baseUrl}/user/checkUserDeActivate`,body),
    userDeactivation : (body) =>
        axios.post(`${baseUrl}/user/deactivate`,body),
    getUserData: (body) =>{
        return axios.post(`${baseUrl}/getUsersNew`, body);
    },
    getUserCount : ()=>{
        return axios.get(`${baseUrl}/getUsersCount`);
    }



};
export default userServices;
